module.exports = __webpack_public_path__ + "img/Taran.e055ba40.jpg";